import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";

const Pending2 = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();

  const role = localStorage.getItem("role");

  const stats = [
    { label: "Yet to Start - 2", value: 3, path: "/table-inventory" },
    { label: "Dispatch - 3", value: 4, path: "/dispatch-table" },
    { label: "Delivered - 5", value: 4, path: "/delivery-table" },
    { label: "Technical Support - 5", value: 3, path: "/table-technical" },
  ];

  const technicalStats = [
    { label: "Yet to Start(20)", value: 3, path: "/table-inventory" },
    { label: "Issue Resolved(20)", value: 4, path: "/dispatch-table" },
    { label: "Super Admin(20)", value: 4, path: "/delivery-table" },
    { label: "Inventory Support(20)", value: 3, path: "/table-technical" },
  ];

  const handleClick = (index, path) => {
    setActiveIndex(index);
    navigate(path);
  };

  return (
    <div>
      <Topbar header="Pending" subHead="Move" />
      <div className="container_fluit1 px-4 py-3">
        {role == "Inventory" ? (
          <div className="d-flex flex-wrap gap-3 ac-js">
            {stats.map((item, index) => (
              <div
                key={index}
                className={`box_Value d-flex ac-jc ${activeIndex === index ? "box_Value_active" : ""
                  }`}
                onClick={() => handleClick(index, item.path)}
                style={{ cursor: "pointer" }}
              >
                <button
                  className="m-0 btn w-100 text-wrap f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                  style={{
                    border: "none",
                    background: "transparent",
                    color: activeIndex === index ? "white" : "black",
                  }}
                >
                  {item.label}
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="d-flex flex-wrap gap-3 ac-js">
            {technicalStats.map((item, index) => (
              <div
                key={index}
                className={`box_Value d-flex ac-jc ${activeIndex === index ? "box_Value_active" : ""
                  }`}
                onClick={() => handleClick(index, item.path)}
                style={{ cursor: "pointer" }}
              >
                <button
                  className="m-0 btn w-100 text-wrap f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                  style={{
                    border: "none",
                    background: "transparent",
                    color: activeIndex === index ? "white" : "black",
                  }}
                >
                  {item.label}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Pending2;
